import { useEffect } from 'react';

import { SNOWPLOW_TRIGGER } from 'Utilities/analytics';

import {
  OptimizelyScript,
  useBroadcast,
  useCognito,
  useCookieCheck,
  useGA,
  useOptimizely,
  useSignInConsent,
  useSnowplow,
  useUTM,
} from './initHooks';

const initHooks = [
  useBroadcast,
  useCookieCheck,
  useGA,
  useOptimizely,
  useSignInConsent,
  useSnowplow,
  useUTM,
  useCognito,
  // Needs to be the last hook
  () => useEffect(() => {
    SNOWPLOW_TRIGGER('trackPageView');
  }, []),
]
  .map((hook) => () => {
    hook();
    return null;
  })
  .map((Hook, index) => (
    <Hook key={index} />
  ));

export const Init = () => (
  <>
    {initHooks}
    <OptimizelyScript />
  </>
);
